import type { CallbackState } from './Callback'

export function createCallbackState(state: CallbackState): string {
  if (typeof state === 'string') {
    return btoa(state)
  }

  return btoa(JSON.stringify(state))
}
